(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/dialogs/user-low-balance.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/dialogs/user-low-balance.js');

'use strict';

class UserLowBalance extends svs.tur.payment.dialogs.DialogBase {
  constructor(_ref) {
    let {
      onConfirm,
      onCancel,
      price,
      balance,
      isSyndicate,
      returnUrl
    } = _ref;
    super({
      onConfirm,
      onCancel
    });
    this.balance = balance;
    this.price = price;
    this.isSyndicate = isSyndicate;
    this.returnUrl = returnUrl;
    this.show();
  }
  getIcon() {
    return 'deposit';
  }
  getTitle() {
    if (this.isSyndicate) {
      return this.getSyndicateTitle();
    }
    return 'Du behöver sätta in pengar för att kunna betala ditt spel.';
  }
  getMessage() {
    const message = [];
    if (this.balance) {
      message.push({
        type: svs.components.dialog.message.TEXT,
        text: "Saldo: ".concat(svs.utils.format.Currency(this.balance), " kr"),
        align: svs.components.dialog.message.align.CENTER
      });
    }
    if (this.price) {
      message.push({
        type: svs.components.dialog.message.TEXT,
        text: "Pris: ".concat(svs.utils.format.Currency(this.price), " kr"),
        align: svs.components.dialog.message.align.CENTER
      });
    }
    return message;
  }
  getActions() {
    if (this.isSyndicate) {
      return this.getSyndicateActions();
    }
    return [{
      type: svs.components.dialog.button.SECONDARY,
      title: 'Avbryt',
      callback: (e, form, dialog) => {
        dialog.close(() => {
          this.onCancel && this.onCancel();
        });
      }
    }, {
      type: svs.components.dialog.button.SECONDARY,
      title: 'Sätt in',
      callback: (e, form, dialog) => {
        this.onConfirm && this.onConfirm();
        dialog.close(() => {
          svs.utils.form.postToUrl(svs.core.urlMapping.get('transactionsHome'), {
            returnUrl: this.returnUrl || window.location
          });
        });
      }
    }];
  }
  getSyndicateTitle() {
    const syndicateName = svs.tur.payment.utils.misc.getSyndicateName();
    return "Laget".concat(syndicateName ? " ".concat(syndicateName) : '', " har inte tillr\xE4ckligt med pengar f\xF6r att betala spelet.");
  }
  getSyndicateActions() {
    return [{
      type: svs.components.dialog.button.SECONDARY,
      title: 'Avbryt',
      callback: (e, form, dialog) => {
        dialog.close(() => {
          this.onCancel && this.onCancel();
        });
      }
    }, {
      type: svs.components.dialog.button.SECONDARY,
      title: 'Sätt in',
      callback: (e, form, dialog) => {
        this.onConfirm && this.onConfirm();
        dialog.close(() => {
          svs.utils.url.navigate(svs.core.urlMapping.get('playTogetherTeams'));
        });
      }
    }];
  }
}
svs.tur.payment.dialogs.UserLowBalance = UserLowBalance;

 })(window);